import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Utils$dElm from "../Utils.Elm/index.js";
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const holdDyn = /* #__PURE__ */ Specular$dFRP$dBase.foldDyn({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(x => v => x);
const toDomEvent = Unsafe$dCoerce.unsafeCoerce;
const specularView = widget$p => node => state => dispatch => Utils$dElm.onInitOrUpdate(node)((() => {
  const $0 = Specular$dDom$dWidget.runWidgetInNode(node)(Specular$dInternal$dRIO.bindImpl(newEvent)(updateState => Specular$dInternal$dRIO.bindImpl(holdDyn(state)(updateState.event))(stateDyn => Specular$dInternal$dRIO.bindImpl(widget$p(stateDyn)(x => dispatch(x)))(action => Specular$dInternal$dRIO.pureImpl(updateState.fire)))));
  return () => {
    const a$p = $0();
    return a$p._1;
  };
})())(updateState => updateState(state));
export {holdDyn, newEvent, specularView, toDomEvent};
